import React, { useEffect, useImperativeHandle, useState } from "react";
import { Form, FormInstance, Space, Divider, message } from "antd";
import { config, catalog_2 } from "./config/config";
import "./MedicalHistory.scss";
import FormInput2 from "./components/FormInput2/FormInput2";
import DrugAllergies from "./components/DrugAllergies/DrugAllergies";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tabKeys } from "types/enums";
import { setDetailPhieu } from "redux/reducer/nurseOut";
import { checkEmptyObj, isValuable, jsonParse } from "helper/common";
import { nurseOutService } from "api";

const MedicalHistory = React.forwardRef<any>((props: any, ref) => {
  const detailPhieu = useAppSelector((state) => state.nurseOut.detailPhieu);

  const [catalog2, setCatalog2] = useState<any>();
  const [form] = Form.useForm();
  const formRef = React.useRef<FormInstance>(null);
  const [formValues, setFormValues] = useState<any>();

  useEffect(() => {
    setCatalog2(catalog_2);
  }, []);

  useEffect(() => {
    if (detailPhieu.jsonDieuDuongDto) {
      let formValue = parseJsonValueToObject(detailPhieu?.jsonDieuDuongDto);
      // console.log(formValue);
      setFormValues({ ...formValue });
      // console.log(1);
    }
    form.setFieldValue(
      ["systemicHistory", "MedicalHistory"],
      detailPhieu?.tienSuBenhToanThan
    );
    form.setFieldValue(
      ["systemicHistory", "FamilyHistory"],
      detailPhieu?.tienSuGiaDinh
    );
    form.setFieldValue(["ophthalmicHistory", "Comments"], detailPhieu?.benhSu);
  }, [detailPhieu]);

  useEffect(() => {
    const setTienSu = async () => {
      if (detailPhieu && !isValuable(detailPhieu?.jsonDieuDuongDto)) {
        const data = await getTienSu(detailPhieu?.id);
        let formValue = parseJsonValueToObject(data);
        console.log(formValue);
        // console.log(formValue);
        setFormValues({ ...formValue, chiefComplaints: { Comments: "" } });
      }
    };
    setTienSu();
  }, [detailPhieu]);
  const getTienSu = async (id) => {
    try {
      const res = await nurseOutService.getChieuCaoCanNangTienSu(id);
      return res;
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    if (!checkEmptyObj(formValues)) {
      form.setFieldsValue({ ...formValues });
    }
    setCatalog2([...catalog_2]);
  }, [formValues]);

  const parseJsonValueToObject = (dataJson) => {
    const data = {
      ...dataJson,
      chiefComplaints: jsonParse(dataJson?.chiefComplaints),
      contactAllergies: jsonParse(dataJson?.contactAllergies),
      intraocularPressure: jsonParse(dataJson?.intraocularPressure),
      ophthalmicHistory: jsonParse(dataJson?.ophthalmicHistory),
      drugAllergies: jsonParse(dataJson?.drugAllergies),
      foodAllergies: jsonParse(dataJson?.foodAllergies),
      systemicHistory: jsonParse(dataJson?.systemicHistory),
    };
    return data;
  };

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return form.getFieldsValue();
    },
  }));
  const onFinish = (value) => {};
  return (
    <div id="medicine-info">
      {formValues && (
        <Form
          name="basic"
          ref={formRef}
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          // initialValues={formValues}
        >
          {catalog2 && (
            <Space style={{ width: "100%" }} direction="vertical" size={50}>
              <Space
                style={{ width: "100%" }}
                direction="vertical"
                size={"small"}
              >
                {/* Other */}
                {catalog2.map((c, index) => (
                  <Space
                    direction="vertical"
                    size={"small"}
                    key={index}
                    style={{ width: "100%" }}
                  >
                    <>
                      {index == 5 || index == 3 ? (
                        <>
                          {/* {formRef && (
                            <DrugAllergies c={catalog2} formRef={formRef} />
                          )}{" "} */}
                        </>
                      ) : (
                        <>
                          <FormInput2
                            formRef={formRef}
                            catalog={c}
                            childrenName={[]}
                          ></FormInput2>
                          <Divider style={{ margin: 12 }}></Divider>
                        </>
                      )}
                    </>
                  </Space>
                ))}
              </Space>
            </Space>
          )}
        </Form>
      )}
    </div>
  );
});
export default MedicalHistory;
